export const CancelPath = {
  CONFIRM: 'confirm',
}
